import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomProperty, PaidTimeOffPolicy } from "winslow-core";
import { selectUser } from "../../../redux/features/appData";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";

type AppCustomPropertyPTOPoliciesProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyPTOPolicies = ({customProperty, data, validate, onChange} : AppCustomPropertyPTOPoliciesProps) => {

    const storeUser = useSelector(selectUser);
    const [paidTimeOffPolicies, setPaidTimeOffPolicies] = useState<PaidTimeOffPolicy[] | undefined>(undefined);
    const [selected, setSelected] = useState<string[]>([]);

    useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        (async () => {
            const paidTimeOffPolicies = await apiGetPaidTimeOffPoliciesForWorkspace(storeUser?.currentWorkspaceId || "");

            if (paidTimeOffPolicies) {
                setPaidTimeOffPolicies(paidTimeOffPolicies);
            }
        })();
    }, [storeUser]);

    useEffect(() => {
        onChange(customProperty.label, selected);
    }, [selected]);

    return (
        
        <div className="app-custom-property-multiple">
            {paidTimeOffPolicies && paidTimeOffPolicies.map((policy, index) => (
                <div key={index} className="app-custom-property-multiple-choice">
                    <input
                        type="checkbox"
                        name="system-PTOPolicies"
                        checked={selected.includes(policy.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelected([...selected, policy.id]);
                            } else {
                                setSelected(selected.filter(p => p !== policy.id));
                            }
                        }}
                    />
                    
                    <div style={{width: "100%", flexShrink: 0}}>{policy.name}</div>
                    
                </div>
            ))}
        </div>
            
    )
}
